import React, { useState } from 'react';
import style from '@src/js/Style';
import Card from '@src/js/Components/Base/Card';

export default class Alarm extends React.Component {

    constructor(props) {

        super(props);

        this.items = {};
        this.state = { id: 0, content: [] };
    }

    //------------------------------------------------------------------------------------------------------------------
    // RENDER
    //------------------------------------------------------------------------------------------------------------------

    render() {

        if (!this.state.content || this.state.content.length < 1)
            return null;

        return (
            <div className={ style('fixed-top p-4 flex flex-wrap gap-md') }>
                { this.state.content }
            </div>
        );
    }

    renderMessage(id, props) {

        return (
            <Card key={ id } className={ style('w-full shadow-2xl m-auto size-x-400') }>
                <div className={ style(`flex justify-between items-start ${props.title ? 'flex-wrap': ''}`.trim()) }>
                    { this.renderHead(id, props) }
                    { this.renderBody(id, props) }
                </div>
            </Card>
        );
    }

    renderHead(id, props) {

        if (props.title != undefined) {

            return (
                <div className={ style('w-full flex justify-between items-center pt-1') }>
                    <div className={ style('title3') }>{ props.title }</div>
                    { this.renderClose(id, props) }
                </div>
            );
        }
    }

    renderBody(id, props) {

        return (<>
            <div className={ props.title ? style(`${props.title ? 'border-top pt-4 mt-4' : ''}`) : null }>
                { props.message }
            </div>
            { props.title != undefined ? null : this.renderClose(id, props) }
        </>);
    }

    renderClose(id, props) {

        if (props.timeout) {

            let
                countdown = props.timeout,
                countdownElement = null;

            const

                intervalId = setInterval(() => {

                    if (countdown > 0) {
                        
                        countdown--;
                        if (countdownElement)
                            countdownElement.innerText = countdown;
                    }
                    else {

                        clearInterval(intervalId);
                        this.hide(id);
                    }

                }, 1000);

            return (
                <div className={ style('flex-center') }>
                    <div className={ style('title6 text-muted px-2') } ref={ (node) => { countdownElement = node; } }>
                        { countdown }
                    </div>
                    <i className={ style('icon-close title3') } onClick={ () => this.hide(id) }></i>
                </div>
            );
        }

        return <i className={ style('icon-close title3') } onClick={ () => this.hide(id) }></i>;
    }

    //------------------------------------------------------------------------------------------------------------------
    // ACTIONS
    //------------------------------------------------------------------------------------------------------------------

    show(props = { type, title, message, timeout }) {

        const id = ++this.state.id;
        this.items[id] = this.renderMessage(id, props);

        this.setState({ content: Object.values(this.items) });

        if (props.timeout != undefined)
            setTimeout(() => this.hide(id), props.timeout * 1000);
    }

    hide(id) {

        // this.state.content = this.state.content.filter((alarm) => alarm.key != id);
        delete this.items[id];
        
        this.setState({ content: Object.values(this.items) });
    }

    hideAll() {

        this.items = [];
        this.setState({ content: [] });
    }
}